import React from "react";

import { useTranslation } from "react-i18next";
import ReactApexChart from "react-apexcharts";
import { Shimmer, ShimmerElementsGroup, ShimmerElementType } from '@fluentui/react/lib/Shimmer';
import { countBy } from "../../common/Helpers";
import PropTypes from 'prop-types';

const AccessesPerMonthTotalPai = (props) => {
    const { t } = useTranslation();

    const inputParam_ChartData = props.chartData !== undefined && props.chartData !== null ? props.chartData : null;

    const _aux_chartData = inputParam_ChartData !== null ? countBy(inputParam_ChartData, "legalEntityTypeId") : null;

    const chartConfig = inputParam_ChartData !== null ? {          
      series:  [_aux_chartData["1"], _aux_chartData["3"]],
      options: {
          labels: [t('data-lang-charts-eecc'), t('data-lang-charts-mandant')],
          plotOptions: {
            pie: {
              dataLabels: {
                offset: -5
              }
            }
          },
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                show: false
              },
              labels: [t('data-lang-charts-eecc'), t('data-lang-charts-mandant')],
            }
          }],
          legend: {
            show: true
          }
        }
    } : null;

    return (
      <>
        {chartConfig &&
          <ReactApexChart options={chartConfig.options} series={chartConfig.series} type="donut" width="100%" height="250px" />
        }
        {!chartConfig &&
          <Shimmer
              customElementsGroup={
                <div style={{ display: 'flex' }}>
                  <ShimmerElementsGroup
                      shimmerElements={[
                          { type: ShimmerElementType.gap, height: 232 },
                        ]}
                  />
                  <ShimmerElementsGroup
                      shimmerElements={[
                          { type: ShimmerElementType.circle, height: 232 },
                        ]}
                  />
                  <ShimmerElementsGroup
                      flexWrap
                      width="100%"
                      shimmerElements={[
                          { type: ShimmerElementType.gap, width: '50%', height: 58 },
                          { type: ShimmerElementType.line, width: '50%', height: 20 },
                          { type: ShimmerElementType.gap, width: '50%', height: 58 },
                          { type: ShimmerElementType.line, width: '50%', height: 20 },
                          { type: ShimmerElementType.gap, width: '50%', height: 58 },
                          { type: ShimmerElementType.line, width: '50%', height: 20 },
                          { type: ShimmerElementType.gap, width: '50%', height: 58 },
                          { type: ShimmerElementType.line, width: '50%', height: 20 },
                      ]}
                  />
                </div>
              }
              className="pt-4"
              isDataLoaded={chartConfig !== null}>
          </Shimmer>
        }
      </> 
    );
};
AccessesPerMonthTotalPai.propTypes = {
  chartData: PropTypes.object.isRequired,
};
export default AccessesPerMonthTotalPai;